import Vue from 'vue';

export const AdminSlotAboveEntryForm = Vue.component(
    'AdminSlotAboveEntryForm',
    require('~/components/AdminSlots/AboveEntryForm/AboveEntryForm.vue')
);

export const AdminSlotAboveInfoPanel = Vue.component(
    'AdminSlotAboveInfoPanel',
    // `.default` is required — webpack returns the ES module namespace for a required
    // .vue, so without it Vue registers the wrapper object and the slot never mounts.
    require('~/components/AdminSlots/AboveInfoPanel/AboveInfoPanel.vue').default
);

export const AdminSlotBelowEntryForm = Vue.component(
    'AdminSlotBelowEntryForm',
    require('~/components/AdminSlots/BelowEntryForm/BelowEntryForm.vue')
);

export const AdminSlotBelowHelpBlock = Vue.component(
    'AdminSlotBelowHelpBlock',
    require('~/components/AdminSlots/BelowHelpBlock/BelowHelpBlock.vue')
);

export const AdminSlotBelowInfoPanel = Vue.component(
    'AdminSlotBelowInfoPanel',
    require('~/components/AdminSlots/BelowInfoPanel/BelowInfoPanel.vue')
);

export const AdminSlotBelowQuickSearch = Vue.component(
    'AdminSlotBelowQuickSearch',
    require('~/components/AdminSlots/BelowQuickSearch/BelowQuickSearch.vue')
);

export const AdminSlotInsideEntryFormFooterBar = Vue.component(
    'AdminSlotInsideEntryFormFooterBar',
    require('~/components/AdminSlots/InsideEntryFormFooterBar/InsideEntryFormFooterBar.vue')
);
